import { TSelectOptionType } from '@components/common/Select/Select.types';

import { ETimeAggregationTypes } from '@enums/common';
import { EGranularitiesLabels, EGranularitiesValues } from '@enums/kpi-common';

export const invalidRangeError = 'The Start date must be less than or equal to the End date';

const includedValues = new Set<typeof EGranularitiesValues[keyof typeof EGranularitiesValues]>([
	EGranularitiesValues.monthly,
	EGranularitiesValues.hourly,
	EGranularitiesValues.daily,
]);

export const granularitiesList = Object.entries(EGranularitiesValues)
	.map(([key, value]) => ({
		value,
		label: EGranularitiesLabels[key as keyof typeof EGranularitiesLabels],
	}));

export const automaticGranularitiesList = granularitiesList
	.filter(({ value }) =>
		includedValues.has(value as typeof EGranularitiesValues[keyof typeof EGranularitiesValues]));

export const GranularityToTimeAggregationMap = {
	[EGranularitiesValues.daily]: ETimeAggregationTypes.days,
	[EGranularitiesValues.hourly]: ETimeAggregationTypes.hours,
	[EGranularitiesValues.monthly]: ETimeAggregationTypes.months,
	[EGranularitiesValues.every_minute]: ETimeAggregationTypes.minutes,
	[EGranularitiesValues.every_15_minute]: ETimeAggregationTypes.interval,
} as const;

export const TimeAggregationToGranularityMap = {
	[ETimeAggregationTypes.days]: EGranularitiesValues.daily,
	[ETimeAggregationTypes.hours]: EGranularitiesValues.hourly,
	[ETimeAggregationTypes.months]: EGranularitiesValues.monthly,
	[ETimeAggregationTypes.minutes]: EGranularitiesValues.every_minute,
	[ETimeAggregationTypes.interval]: EGranularitiesValues.every_15_minute,
} as const;

export const SEARCH_BY_SITE_OR_CELL_ID_PLACEHOLDER = 'Search by site ID/cell ID';

export const SELECT_SITES_OR_CELLS_LABEL = 'Select sites/cells';

export const KPI_SELECTION_LIMIT_EXCEEDED_TEXT = `You have exceeded the maximum selection limit ({selected}/{max}).
Please remove existing selections to stay within the limit.`;

export const MAX_DATE_OFFSET_DAYS = 365;

export const dateOffsetOptions: TSelectOptionType<number>[] = Array.from({ length: MAX_DATE_OFFSET_DAYS }, (_, i) => {
	const day = i + 1;

	return {
		label: day.toString(),
		value: day,
	};
});
